<template>
	<div class="container audit-card mx-auto">
		<div class="row">
			<div class="col-7 col-md-12 col-lg-7 my-auto text-left">
				<span class="w-100 font-weight-bold">{{venue_name}}</span>
				<div v-if="auditors.length" class="w-100 audit-card--who-when">
					<i>Assigned to</i>
					<div v-for="auditor in auditors" class="w-100"> - {{auditor.first_name + ' ' + auditor.last_name}}</div>
				</div>
				<div v-else class="w-100 audit-card--who-when">
					<span>Last audited {{last_audited}}</span>
				</div>
			</div>
			<div class="col-5 col-md-12 col-lg-5 my-auto text-right text-md-left text-lg-right">
				<a :href="schedule_url" v-if="auditors.length" class="btn btn-primary">Reassign</a>
				<a :href="schedule_url" v-else class="btn btn-primary">Assign</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'venue_name', 'last_audited', 'auditors', 'schedule_url'
		],
	}
</script>
